import React, { useEffect, useState } from "react";
import "./style/style.less";
import FormItme from "./loginformitem";
import Register from "./register";
import Forgotpassword from "./Forgotpassword";
import { observer } from "mobx-react";
import { aidConfig } from "@/platformConfig";
const LoginForm = () => {
  const [fromactive, setfromactive] = useState(0);
  const [loginregister, setloginregister] = useState(0);

  const [forgotpassword, setforgotpassword] = useState(false);
  const handefogetpasword = (e) => {
    if (!forgotpassword && e) setforgotpassword(true);
  };

  const handeformpassrod = (activeprops: boolean) => {
    if (activeprops) {
      setforgotpassword(false);
      setloginregister(0);
      setfromactive(0);
    }
  };
  const [overHeight, setOverHeight] = useState<boolean>(false);
  useEffect(() => {
    const image = new Image();
    image.src = aidConfig.loginIcon;
    image.onload = function () {
      setOverHeight(image.height >= image.width);
    };
  }, []);
  const AccountloginSMS = observer(() => {
    return (
      <div>
        <div className={"logo-nav"}>
          <img
            src={aidConfig.loginIcon}
            style={{ width: overHeight ? "auto" : "80%", height: overHeight ? "80px" : "auto" }}
          />
        </div>
        <div className="logo-title">{aidConfig.text}-代理商平台</div>
        {loginregister === 0 && (
          <div>
            <div className="login-formtomsgt">
              <div>
                <span
                  className={!fromactive ? "login-form-active" : "login-form-sub-title "}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setfromactive(0);
                  }}
                >
                  账号登录
                </span>
                {!fromactive && <p className="Tableactive"></p>}
              </div>
              <div>
                <span
                  className={fromactive ? "login-form-active" : "login-form-sub-title "}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setfromactive(1);
                  }}
                >
                  短信登录
                </span>
                {fromactive ? <p className="Tableactive"></p> : ""}
              </div>
            </div>
            <div className="error-msg"></div>
            <FormItme active={fromactive} passonchang={handefogetpasword}></FormItme>
          </div>
        )}

        {loginregister === 1 && <Register></Register>}
      </div>
    );
  });

  return (
    <div className="login-form-wrapper" style={{ position: "relative" }}>
      {forgotpassword ? (
        <Forgotpassword handeonclick={handeformpassrod}></Forgotpassword>
      ) : (
        <AccountloginSMS></AccountloginSMS>
      )}
    </div>
  );
};
export default LoginForm;
